import { Polygon } from "geojson";
import { useMemo } from "react";
import { useMap } from "react-map-gl";
import { useDrawMapStore, usePipedriveStore, useTenantInMarketStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import { ITenantInMarketState } from "../interfaces/ITenantInMarket";
import GeometryService from "../services/geometryService";
import ParcelApiService from "../services/parcelApiService";

const useTenantInMarketCreate = (): (tenantInMarketState: ITenantInMarketState) => Promise<number> => {
    const map = useMap().map!;
    const tenantInMarketStore = useTenantInMarketStore();
    const pipedriveStore = usePipedriveStore();
    const drawMapStore = useDrawMapStore();
    const geometryService = useMemo(() => new GeometryService(), []);
    const parcelApiService = useMemo(() => new ParcelApiService(), []);

    return async (tenantInMarketState: ITenantInMarketState): Promise<number> => {
        try {
            const polygon = drawMapStore.result!.features[0].geometry as Polygon;
            const centerPoint = geometryService.getPolygonCenterPoint(polygon);
            const county = parcelApiService.getCountyName(map, centerPoint);
            const state = parcelApiService.getStateAbbrevByPoint(map, centerPoint);

            const createdTenantInMarketId = await tenantInMarketStore.createTenantInMarket(
                tenantInMarketState,
                await pipedriveStore.getOrCreatePipedriveOrganizationId(tenantInMarketState.pipedriveCompanyName),
                await pipedriveStore.getOrCreatePipedriveOrganizationId(tenantInMarketState.pipedriveBrokerageName),
                geometryService.mapPolygonToShape(polygon),
                `${county}, ${state}`,
            );

            showSuccessToast();

            return createdTenantInMarketId;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useTenantInMarketCreate;
